<template>
<div class=" w-1200">
  <div class="mail-detail" v-loading="loading">
    <div class="title">
      <span class="title-text" v-if="detail">{{detail.title}}</span>
    </div>
    <div class="content">
      <div class="content-item">
        <span class="content-item-label">发送时间：</span>
        <span class="content-item-value">{{detail.created_at}}</span>
      </div>
      <div class="content">
        {{detail.content}}
      </div>
      <div class="footer">
        <el-button type="primary" @click="handleBack">返回上一页</el-button>
      </div>
    </div>
  </div>
</div>

</template>
<script>
import { messageDetail } from "@/api/modules/user.js";
export default {
  name:'mail-detail',
  data() {
    return {
      id: this.$route.query.id,
      detail:{},
      loading:false
    }
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.loading = true;
      messageDetail(this.id).then(res => {
        if(res.data.code==10000){
          this.detail = res.data.data;
          this.loading = false;
        }
      });
    },
    handleBack() {
      this.$router.back();
    }
  }
}
</script>
<style lang="scss" scoped>
.mail-detail{
  margin: 40px 0;
  background: #fff;
  padding: 20px;
  .title{
    font-size: 24px;
    font-weight: bold;
  }
  .content-item{
    margin: 20px 0;
    .content-item-label{
      font-size: 16px;
      font-weight: bold;
    }
    .content-item-value{
      font-size: 16px;
    }
  }
  .footer{
    text-align: right;
  }
}
</style>
